export default __webpack_public_path__ + "static/media/icon_error503.14f2c986.svg";